import React, { useState } from "react";
import { Button, Dropdown } from "react-bootstrap";
import { FiPlus, FiUpload } from "react-icons/fi";
import AddCertificationModal from "../../modals/hrm/training/certificationtracking/AddCertificationModal";

import { RiHome6Line } from "react-icons/ri";
import { MdKeyboardArrowRight } from "react-icons/md";
import { Link } from "react-router-dom";
import { Breadcrumb, Col } from 'react-bootstrap';

export default function CertificationTrackingHeader() {
  const [showModal, setShowModal] = useState(false);

  return (
    <div >

      {/* HEADER */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          flexWrap: "wrap",
          marginBottom: 20,
          alignItems:"center",
        }}
      >
 
   <Col md={4} sm={12}>
                  <div className="my-auto mb-2">
                    <h4 style={{ fontWeight: "600", marginBottom: "5px" }}>Certification Tracking</h4>
        
                    <Breadcrumb
                      style={{
                        background: "transparent",
                        padding: 0,
                        margin: 0,
                        fontSize: "14px",
                      }}
                    >
                      <Breadcrumb.Item>
                      <Link  to="/" >
               
                        <RiHome6Line
                          className="m text-dark"
                          style={{
                            fontSize: "1.2rem", // increased icon size
                            verticalAlign: "middle",
                                                     }}
                        /></Link>
                      </Breadcrumb.Item>
        
                      <MdKeyboardArrowRight className="mt-1 fs-5" />
        
                      <Breadcrumb.Item
                        linkAs="span"
                        className="text-dark text-decoration-none fs-6"
                      >
                      Training
                      </Breadcrumb.Item>
        
                      <MdKeyboardArrowRight className="mt-1 fs-5" />
        
                      <Breadcrumb.Item active>
                        <span className="text-dark fs-6">Certification Tracking</span>
                      </Breadcrumb.Item>
                    </Breadcrumb>
                  </div>
                </Col>



        {/* RIGHT BUTTONS */}
        <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
          <Dropdown>
            <Dropdown.Toggle
              style={{
                background: "#fff",
                color: "#111",
                border: "1px solid #ddd",
              }}
            >
              <FiUpload /> Export
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Dropdown.Item>Export as PDF</Dropdown.Item>
              <Dropdown.Item>Export as Excel</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>

          <Button
  onClick={() => setShowModal(true)}
  style={{
    background: "#f97316",
    border: "none",
    display: "flex",
    alignItems: "center",
    gap: "6px",
    padding: "9px 12px",      
    fontSize: "14px",         
    borderRadius: "6px",
    height: "34px",           
    whiteSpace: "nowrap",
  }}
>
  <FiPlus size={16} /> 
  Add New Certification
</Button>
        </div>
      </div>

      {/* MODAL */}
      <AddCertificationModal
        show={showModal}
        onHide={() => setShowModal(false)}
      />
    </div>
  );
}